import {
  LlmConfirmationModes,
  type LlmConfirmationModeEnum,
} from '../../enums/LlmConfirmationModeEnum'

interface IDeriveLlmConfirmationModeInput {
  showConversationConfirmation: boolean
  isAmbiguousIntent: boolean
  hasResultItems: boolean
}

export function deriveLlmConfirmationMode(
  input: IDeriveLlmConfirmationModeInput
): Nullable<LlmConfirmationModeEnum> {
  if (input.isAmbiguousIntent) {
    return LlmConfirmationModes.WITH_RESULTS
  }
  if (!input.showConversationConfirmation) {
    return null
  }
  return input.hasResultItems
    ? LlmConfirmationModes.WITH_RESULTS
    : LlmConfirmationModes.REPLACES_RESULTS
}
